import './SuggestionCards.scss';
import {
  ArrowUp,
  Copy,
  Danger,
  Dislike,
  Edit,
  Flash,
  Grid1,
  Judge,
  Key,
  Like1,
  Refresh,
  Refresh2,
  Save2,
  SaveAdd,
  TickCircle,
  Warning2,
} from 'iconsax-react';

import {
  DocumentText,
  Graph,
  Note,
  SearchNormal,
  MessageQuestion,
  ClipboardText,
  DocumentFilter,
  TableDocument,
} from 'iconsax-react';
import { Pencil } from 'lucide-react';

const SuggestionCards = ({ onClick }) => {
  return (
    <div className="flex flex-col items-center w-full mt-[80px] mb-[60px] px-2">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 w-full max-w-[860px]">
        {[
          {
            icon: <Edit size="20" color="#475467" variant="Outline" />,
            label: 'Elabore um parecer',
          },
          {
            icon: <Judge size="20" color="#475467" variant="Outline" />,
            label: 'Compile Jurimetria',
          },
          {
            icon: <Key size="20" color="#475467" variant="Outline" />,
            label: 'Proponha argumentos',
          },
          {
            icon: (
              <DocumentFilter size="20" color="#475467" variant="Outline" />
            ),
            label: 'Análise de riscos',
          },
          {
            icon: <TableDocument size="20" color="#475467" variant="Outline" />,
            label: 'Elabore resumos',
          },
          {
            icon: <SearchNormal size="20" color="#475467" variant="Outline" />,
            label: 'Identifique citações',
          },
          {
            icon: <Flash size="20" color="#475467" variant="Outline" />,
            label: 'Mapeie tendências',
          },
          {
            icon: <Grid1 size="20" color="#475467" variant="Outline" />,
            label: 'Estruture tabelas',
          },
          {
            icon: <Warning2 size="20" color="#475467" variant="Outline" />,
            label: 'Aponte divergências',
          },
        ].map((service, index) => (
          <button
            key={index}
            className="flex items-center w-[280px] h-[70px] gap-3 px-4 py-3 bg-white border border-[#E4E7EC] rounded-[8px] shadow-[0px_1px_3px_rgba(0,0,0,0.06),_0px_2px_1px_rgba(0,0,0,0.04)] transition hover:shadow-md"
            onClick={() => onClick(service.label)}
          >
            <div className="p-2 bg-[#F2F4F7] rounded-md">{service.icon}</div>
            <span className="text-base font-poppins text-[#101828] font-normal">
              {service.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuggestionCards;

// import './SuggestionCards.scss';

// const SuggestionCards = ({ text, onClick }) => {
//   return (
//     <div
//       className="card-suggestion border border-solid border-gray-50 shadow"
//       onClick={() => onClick(text)}
//     >
//       <p className="text-sm text-gray-900 leading-snug">
//         {text}{' '}
//         <span className="text-blue-600 group-hover:translate-x-1 inline-block transition-transform duration-200">
//           →
//         </span>
//       </p>
//     </div>
//   );
// };

// export default SuggestionCards;
